import React from 'react';

import config from 'config';

import { loadMembership, loadProfile } from '@techstyle/react-accounts';
import { loadSession } from '@techstyle/redux-core';

import { CioClientProvider } from './src/components/CioClientProvider/CioClientProvider';
import { getBuilderPageTargeting } from './src/utils/getBuilderPageTargeting';

const transformUserAttributesToCioSegments = userAttributes => {
  if (!userAttributes) {
    return [];
  }

  return Object.entries(userAttributes)
    .filter(([, value]) => Boolean(value))
    .map(([key, value]) => `${key}|${value}`);
};
export const withConstructorProvider = App => {
  const getInitialProps = App.getInitialProps;

  function WithConstructorClient(props) {
    return <App {...props} />;
  }

  if (getInitialProps) {
    WithConstructorClient.getInitialProps = async pageCtx => {
      const keys = config.get('public.constructorio.keys');
      const ConstructorIOClient = process.browser
        ? require('@constructor-io/constructorio-client-javascript')
        : require('@constructor-io/constructorio-node');

      const ctx = 'Component' in pageCtx ? pageCtx.ctx : pageCtx;
      const { store } = ctx;
      await Promise.all([
        store.dispatch(loadSession()),
        store.dispatch(loadProfile()),
        store.dispatch(loadMembership()),
      ]);
      const { tld } = store.getState().domain;
      const { customerKey } = store.getState().customer;

      const { userAttributes } = await getBuilderPageTargeting({
        store,
        isPreview: false,
        dispatch: store.dispatch,
      });

      const constructorClient = new ConstructorIOClient({
        apiKey: keys[tld],
        userId: customerKey,
        segments: transformUserAttributesToCioSegments(userAttributes),
      });

      ctx.constructorClient = constructorClient;

      const initialProps = await getInitialProps(pageCtx);
      return initialProps;
    };
  }

  return WithConstructorClient;
};

export default function constructorIoExtension() {
  return {
    id: 'constructorIo',
    app: {
      enhance(App) {
        return withConstructorProvider(App);
      },
      getInitialProps: {
        enhance(getInitialProps) {
          return async ({ Component, ctx }) => {
            const initialProps = await getInitialProps({ Component, ctx });

            return initialProps;
          };
        },
      },
      render(initialProps, children) {
        return <CioClientProvider>{children}</CioClientProvider>;
      },
    },
  };
}
